'use strict';
import { Inject, Injectable } from "ng-metadata/core";
import { getBackendSystem, getInstitutionCode, getVid } from "../../../appConfig/appConfigForward";

@Injectable()
export class BarcodeSearchService {

    private _noResultsBarcodeSearchTerm: string = '';
    private _fromBarcodeSearchToSearchCriteria: boolean = false;
    private _fromSearchCriteriaToBarcodeSearch: boolean = false;
    private _barcodeSearchPerformed: boolean = false;
    private _barcodeSearchHasNoResults: boolean = false;
    private _barcodeSearchInProgress: boolean = false;
    private restUrl: string;
  

    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService) {
            this.restUrl = getBackendSystem() === 'suprima'? this.restBaseURLs.barcodeSearchURL : this.restBaseURLs.pnxBaseURL + "/barcode";

            if (this.$location.search().searchType === 'barcode' && this.$location.search().barcode){
                this._barcodeSearchPerformed=true;
            }
            
    }


    public getPnxByBarcode(barcodeFromUser) {
        let dataToBeSent = {};
        let url='';
        if (getBackendSystem() === 'suprima'){
            dataToBeSent = {
                vid: getVid() 
            };

            url = this.restUrl + '/' + barcodeFromUser;     
        }
        else {
            dataToBeSent = {
                barcode: barcodeFromUser,
                inst: this.$stateParams['inst'] || getInstitutionCode(),
                lang: this.$translate.use()
            };

            url=this.restUrl;   
        }  

        return this.$http.get(url, {params: dataToBeSent});
	}

    public isBarcodeSearchHasNoResults() {
        return this.barcodeSearchHasNoResults;
    }

    public isSwitchedFromBarcodeToSearchCriteria() {
        return this.fromBarcodeSearchToSearchCriteria;
    }

    public isSwitchedFromSearchCriteriaToBarcodeSearch() {
        return this.fromSearchCriteriaToBarcodeSearch;
    }

    public isBarcodeSearchPerformed() {
        return this.barcodeSearchPerformed;
    }

    public resetBarcodeSearchHasNoResults() {
        this.barcodeSearchHasNoResults=false;
    }

    get noResultsBarcodeSearchTerm() {
        return this._noResultsBarcodeSearchTerm;
    }

    set noResultsBarcodeSearchTerm(value) {
        this._noResultsBarcodeSearchTerm = value;
    }

    get barcodeSearchHasNoResults() {
        return this._barcodeSearchHasNoResults;
    }

    set barcodeSearchHasNoResults(value) {
        this._barcodeSearchHasNoResults = value;
    }

    get fromBarcodeSearchToSearchCriteria() {
        return this._fromBarcodeSearchToSearchCriteria;
    }

    set fromBarcodeSearchToSearchCriteria(value) {
        this._fromBarcodeSearchToSearchCriteria = value;
    }

    get fromSearchCriteriaToBarcodeSearch() {
        return this._fromSearchCriteriaToBarcodeSearch;
    }

    set fromSearchCriteriaToBarcodeSearch(value) {
        this._fromSearchCriteriaToBarcodeSearch = value;
    }

    get barcodeSearchPerformed() {
        return this._barcodeSearchPerformed;
    }

    set barcodeSearchPerformed(value) {
        this._barcodeSearchPerformed = value;
    }

    get barcodeSearchInProgress() {
        return this._barcodeSearchInProgress;
    }

    set barcodeSearchInProgress(value) {
        this._barcodeSearchInProgress = value;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/barcodeSearch/barcodeSearch.service.ts